import { render, staticRenderFns } from "./NotificationConfigDisplaycard.vue?vue&type=template&id=0f2f426e&scoped=true&"
import script from "./NotificationConfigDisplaycard.vue?vue&type=script&lang=ts&"
export * from "./NotificationConfigDisplaycard.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationConfigDisplaycard.vue?vue&type=style&index=0&id=0f2f426e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2f426e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VIcon})
